module.exports = __webpack_public_path__ + "img/yuanmeng-b.470d456.png";